// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "ad254f6/js/" + chunkId + ".js";
};